import { DestroyRef, inject, Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthorizeUser, TokenUpdate } from '../../auth/store/auth.actions';
import { WebMessageDataDto } from '../../clients/sf/models/web-message-data.dto';
import { AppState } from '@auth0/auth0-angular';
import { tokenSelector } from '../../auth/store/auth.selectors';
import { Actions } from '@ngrx/effects';
import { environment } from 'src/environments/environment';

@Injectable()
export class WebMessagesService {
  private readonly actions$ = inject(Actions);
  data$ = fromEvent(window, 'message').pipe(
    takeUntilDestroyed(this.destroyRef),
    tap((event: MessageEvent) => {
      // const allowedOrigins = environment.allowedOrigins;
      const { origin, data } = event;

      // if (!allowedOrigins.includes(origin)) {
      //   console.warn('Invalid origin:', event.origin);
      //   return;
      // }

      if ((data as WebMessageDataDto)?.token) {
        const tokenExists =
          this.store.selectSignal(tokenSelector)()?.length > 0;
        this.store.dispatch(new TokenUpdate({ token: data.token }));

        if (tokenExists) {
          return;
        }
        this.store.dispatch(new AuthorizeUser());
      }
    })
  );

  constructor(
    private readonly store: Store<AppState>,
    private readonly destroyRef: DestroyRef
  ) {
    if (window.self !== window.top) {
      console.warn(
        'The application is inside an iframe. Subscribing to web messages'
      );
      this.data$.subscribe();
    }
  }
}
